import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";

import { zinc } from "./ui/colors";

export default React.memo(function DriverMetaRow({
  totalCount,
  selectedCount,
  visibleCount,
}: {
  totalCount: number;
  selectedCount: number;
  visibleCount: number;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 1.5,
        bgcolor: zinc[800],
        px: 1,
      }}
    >
      {selectedCount > 0 && (
        <>
          <Typography component="span" sx={{ color: zinc[400], fontSize: "0.75rem" }}>
            {selectedCount} {selectedCount === 1 ? "Driver" : "Drivers"} Selected
          </Typography>
          <Typography component="span" sx={{ color: zinc[600], fontSize: "0.75rem", userSelect: "none" }}>
            •
          </Typography>
        </>
      )}
      <Typography component="span" sx={{ color: zinc[400], fontSize: "0.75rem" }}>
        {visibleCount} of {totalCount} Drivers Visible
      </Typography>
    </Box>
  );
});
